import { ArrowRight, Sparkles } from 'lucide-react'

export default function Hero() {
  return (
    <section id="hem" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900/80 via-dark-900/70 to-dark-900" />
        <div className="absolute inset-0 bg-gradient-to-r from-dark-900/90 via-dark-900/50 to-transparent" />
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden z-0">
        <div className="absolute top-1/4 -left-20 w-72 h-72 bg-gold-500/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-gold-400/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 xl:px-20 pt-24">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass mb-6 animate-fade-in">
            <Sparkles className="w-4 h-4 text-gold-400" />
            <span className="text-sm font-medium text-gold-300">Professionell hårvård i Landskrona</span>
          </div>

          {/* Main Heading */}
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight mb-6 animate-slide-up">
            <span className="text-white">Din skönhet,</span>
            <br />
            <span className="text-gradient italic">vår passion</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mb-10 leading-relaxed animate-slide-up" style={{ animationDelay: '0.1s' }}>
            Välkommen till VK Studio – där stil möter expertis. Vi skapar personliga frisyrer 
            som förverkligar din vision och lyfter ditt självförtroende.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 animate-slide-up" style={{ animationDelay: '0.2s' }}>
            <a
              href="https://www.bokadirekt.se/places/vk-studio-54503"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-600 text-dark-900 font-bold rounded-full hover:from-gold-400 hover:to-gold-500 transition-all hover:scale-105 shadow-xl shadow-gold-500/25"
            >
              Boka din tid
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#tjanster"
              onClick={(e) => {
                e.preventDefault()
                document.querySelector('#tjanster')?.scrollIntoView({ behavior: 'smooth' })
              }}
              className="inline-flex items-center gap-2 px-8 py-4 border border-white/20 text-white font-semibold rounded-full hover:bg-white/10 transition-all"
            >
              Utforska våra tjänster
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 mt-16 pt-8 border-t border-white/10 animate-slide-up" style={{ animationDelay: '0.3s' }}>
            <div>
              <div className="text-3xl sm:text-4xl font-display font-bold text-gold-400">15+</div>
              <div className="text-sm text-gray-400 mt-1">Års erfarenhet</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-display font-bold text-gold-400">5000+</div>
              <div className="text-sm text-gray-400 mt-1">Nöjda kunder</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-display font-bold text-gold-400">100%</div>
              <div className="text-sm text-gray-400 mt-1">Dedikation</div>
            </div>
          </div>
        </div>
      </div>

    </section>
  )
}
